import { Flex, Progress, Text } from "@chakra-ui/react";

export function StepProgress({ stepIndex, totalSteps }) {
  const pct = ((stepIndex + 1) / totalSteps) * 100;

  return (
    <Flex align="center" gap="12px" mb={{ base: "16px", md: "20px" }}>
      <Progress
        value={pct}
        size="xs"
        borderRadius="99px"
        bg="rgba(0,74,51,0.1)"
        sx={{ "& > div": { background: "#fc8f04" } }}
        flex="1"
      />
      <Text fontSize="11px" fontWeight="700" color="rgba(0,74,51,0.6)" whiteSpace="nowrap" flexShrink={0}>
        Passo {stepIndex + 1} de {totalSteps}
      </Text>
    </Flex>
  );
}
